<template>
  <div>
    <form data-vv-scope="custom-document-part-1" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">Formulario de Solicitud de Presupuesto {{ anio }}</h2>
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Programa *">
            <v-select
              class="w-100"
              :class="{
                'v-select-danger': errors.has('custom-document-part-1.program')
              }"
              data-cy="program"
              data-vv-as="programa"
              name="program"
              :options="optionsProgram"
              v-model="formData.program"
              v-validate="'required'"
            >
              <template #spinner>
                <b-spinner
                  small
                  v-if="loadingProgram"
                  :style="{ opacity: loadingProgram ? 1 : 0}"
                  variant="primary"
                />
              </template>
              <template slot="no-options">
                no hay programa para el criterio de búsqueda
              </template>
            </v-select>
            <div
              v-if="errors.has('custom-document-part-1.program')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document-part-1.program') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="custom-document-part-2">
      <div class="row my-3">
        <div class="col-md-12">
          <h4>Conceptos Presupuestarios *</h4>
        </div>
        <div class="col-md-12 mt-3">
          <add-budget-concept @add-budget-concept="addBudgetConcept"/>
        </div>
        <div class="col-md-12 mt-3">
          <table-budget-concept
            :budget-concepts="formData.budgetConcepts"
            v-model="formData.budgetConceptsSelected"
            multiple
          />
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="custom-document-part-3">
      <div class="row my-3">
        <div class="col-md-12">
          <b-form-group label="Para el financiamiento de: *">
            <b-form-textarea
              :state="errors.has('custom-document-part-3.financing') ? false : null"
              data-vv-as="financiamiento"
              data-cy="financing"
              name="financing"
              type="text"
              rows="3"
              v-model="formData.financing"
              v-validate="'required'"
              maxLength="1000"
            />
            <div class="row justify-content-between">
              <div class="col-md-6 text-left">
                <div
                  v-if="errors.has('custom-document-part-3.financing')"
                  class="con-text-validation span-text-validation-danger v-enter-to"
                >
                  <span class="span-text-validation">
                    {{ errors.first('custom-document-part-3.financing') }}
                  </span>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <small v-tooltip="'Contador de caracteres'">
                  {{formData.financing.length}}/1000
                </small>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="O.C o N° Factura">
            <b-form-input
              data-vv-as="o.c o nº factura"
              data-cy="number"
              name="number"
              type="text"
              v-model="formData.number"
              maxLength="15"
            />
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="BIP">
            <b-form-input
              data-cy="bip"
              name="bip"
              type="number"
              v-model="formData.bip"
              :formatter="maxLengthNumber"
            />
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Resolución">
            <b-form-input
              data-cy="resolution"
              name="resolution"
              type="number"
              v-model="formData.resolution"
              :formatter="maxLengthNumber"
            />
          </b-form-group>
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
      <div class="row align-items-center mt-5">
        <div class="col-md-12">
          <label>Adjuntar Solicitud de compra Autorizada por DAF</label>
        </div>
        <div class="col-md-3 align-items-end">
          <UploadFile
            permission="*"
            accept="application/pdf, .doc, .docx, .xlsx, .ppt"
            text="Seleccionar documentos"
            v-model="file"
            upload-to="ed"
            :button-class="{ 'btn-block': true, 'mb-5': errors.has('custom-document.fileName') }"
            container-class="w-100"
            @input="addFile()"
          />
        </div>
        <br>
        <div class="col-md-3 align-items-end">
          <b-button
            variant="secondary"
            class="btn-icon mt-1"
            data-cy= "from-repository"
            v-has-permission="'ED060'"
            v-b-modal="'add-file-repository'"
          >
            <feather-icon icon="ServerIcon"/>
            Desde el repositorio
          </b-button>
        </div>
        <div class="col-3" v-for="file in formData.files" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="45px" color="primary" />
            <b class="text-truncate w-100 text-center">{{ file.name }}</b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="removeFile(file.id)"
            />
          </div>
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
      <div class="row mt-3 form-group">
        <label for="requestedBy" class="col-3 col-form-label">Solicitado por:</label>
        <div class="col-3">
          <v-select
            class="w-100"
            data-cy="type-requested"
            v-model="typeRequested"
            :options="optionsTypeRequested"
            :reduce="option => option.value"
            :cleareable="false"
          />
        </div>
        <div class="col-4">
          <list-user
            autocomplete
            class="w-100"
            data-cy="requested-user"
            data-vv-as="usuario"
            name="requested"
            label=""
            placeholder="Selecciona un usuario"
            v-model="formData.requested"
            ref="requested"
            v-if="typeRequested === 'user'"
          />
          <list-groups
            autocomplete
            class="w-100"
            label=""
            placeholder="Selecciona un grupo"
            data-cy="requested-group"
            data-vv-as="grupo"
            name="requested"
            :typeList="1"
            v-model="formData.requested"
            ref="requested"
            v-if="typeRequested === 'group'"
          />
        </div>
      </div>
    </form>
    <div
      v-if="!!error.message"
      class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-right"
    >
      <span class="span-text-validation">
        {{ error.message }}
      </span>
    </div>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
      </vs-button>
    </div>
    <!--<SelectDocRepository
      :add-file="addFileRepo"
      :files="formData.files"
      :remove-file="removeFile"
    />-->
    <repository-selector
      modal-id="add-file-repository"
      :add-file="addFileRepo"
      :files="formData.attachments"
      :remove-file="removeFile"
    />
  </div>
</template>

<script>
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import { ioListOptions } from '@/febos/servicios/api/herramientas.api';
import AddBudgetConcept
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/AddBudgetConcept';
import TableBudgetConcept
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/TableBudgetConcept';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListUser from '@/febos/chile/lists/components/ListUser';
import SelectDocRepository
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import RepositorySelector from "@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue";

export default {
  name: 'SP',
  data() {
    return {
      anio: new Date().getFullYear(),
      saving: false,
      error: {
        message: ''
      },
      errorCierre: '',
      formData: {
        budgetConcepts: [],
        budgetConceptsSelected: [],
        financing: '',
        number: '',
        files: [],
        program: '',
        bip: '',
        resolution: '',
        requested: ''
      },
      file: {},
      loadingProgram: false,
      optionsProgram: [],
      typeRequested: 'user',
      optionsTypeRequested: [
        { value: 'user', label: 'Usuario' },
        { value: 'group', label: 'Grupo' },
      ]
    };
  },
  components: {
    RepositorySelector,
    SelectDocRepository,
    AddBudgetConcept,
    TableBudgetConcept,
    UploadFile,
    ListUser,
    ListGroups
  },
  methods: {
    async addFileRepo(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.files.push(file);
      this.error.message = '';
    },
    maxLengthNumber(value) {
      return String(value).substring(0, 15);
    },
    async loadOptionsProgram() {
      try {
        this.loadingProgram = true;
        const response = await ioListOptions({
          grupoOpcion: 'io.programas.gore',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.optionsProgram = opciones
          .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b))
          .map((option) => ({
            label: option.descripcion,
            value: option.valor
          }));
      } finally {
        this.loadingProgram = false;
      }
    },
    async addFile() {
      if (!Object.keys(this.file).length) {
        return;
      }

      if (this.file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.files.push(this.file);
      this.error.message = '';
    },
    removeFile(id) {
      this.formData.files = this.formData.files.filter((file) => file.id !== id);
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async isValid() {
      const partValidations = await Promise.all([
        this.validateForm('custom-document-part-1'),
        this.validateForm('custom-document-part-3')
      ]);
      if (partValidations.some((step) => !step)) {
        return false;
      }
      return true;
    },
    async save() {
      const isValid = await this.isValid();
      if (!isValid) {
        return;
      }

      if (!this.formData.budgetConceptsSelected.length) {
        this.error.message = 'Debes agregar al menos un concepto presupuestario';
        return;
      }

      this.error.message = '';
      this.saving = true;
      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            numerar: 'si',
            ...this.$route.query,
          },
          formData: {
            ...this.formData,
            ...(!!this.formData.requested.length
              && { requested: this.$refs.requested.getOption() }),
            ...(!!this.formData.files.length
              && { attachments: this.formData.files })
          }
        };
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('SP', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    async addBudgetConcept(row) {
      this.error.message = '';
      this.formData.budgetConcepts.push(row);
      this.formData.budgetConceptsSelected.push(row);
    }
  },
  created() {
    this.loadOptionsProgram();
  }
};
</script>
